module.exports = __webpack_public_path__ + "static/media/orders.7ceaa52a.svg";